import ReactDataGrid from "@inovua/reactdatagrid-community";
import { useCallback, useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { LoadPicksData } from "./LoadPicksData";
import moment from "moment";

function Picking() {
  //----- GET CURRENT USER -----//
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  const UserID = userToken.userId;
  const [countOfProgess, setCountOfProgess] = useState(0);
  const [dataSource, setDataSource] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    try {
      setIsLoading(true);
      console.log("Fetching data for UserID:", UserID);
      const data = await LoadPicksData(UserID);
      setDataSource(data.data);
      data.data.length > 0 ? setDisabled(false) : setDisabled(true);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  // Sets datasource on load and when searchString changes
  useEffect(() => {
    fetchData();
  }, [UserID]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountOfProgess((oldProgress) => {
        if (100 === oldProgress) {
          // Reload the data
          fetchData();
          return 0;
        }
        return oldProgress + 20;
        // return Math.min(oldProgress + Math.random() * 10, 100);
      });
    }, 5000); // Every 5 seconds

    return () => {
      clearInterval(timer);
    };
  }, []);

  // WMS Status Descriptions
  const wmsStatusDescriptions = {
    0: "Loaded",
    1: "Work in Progress",
    2: "Work in Progress",
    3: "Complete",
    5: "Exported",
    6: "Error",
    8: "Picked & Ready for Packing",
    9: "Cancelled",
    10: "Hold",
  };

  const columns = [
    { name: "OrderNo", header: "OrderNo", type: "string", defaultFlex: 0 },
    { name: "Name", header: "Name", type: "string", defaultFlex: 1 },
    { name: "Lines", header: "Lines", type: "number", defaultFlex: 0 },
    {
      name: "Status",
      header: "Status",
      type: "number",
      defaultFlex: 0,
      textAlign: "end",
      render: ({ value }) => {
        // render status as text
        return wmsStatusDescriptions[value];
      },
    },
    {
      name: "Loaded",
      header: "Loaded",
      defaultFlex: 0,
      render({ value }) {
        return moment(value).format("DD/MM/YYYY");
      },
      sort: (a, b) => {
        //console.log("a: ", a, "b: ", b);
        a = moment(a, moment.ISO_8601, true).format();
        b = moment(b, moment.ISO_8601, true).format();

        return new Date(a) - new Date(b);
      },
    },
  ];

  // Styles and setup for grid
  const gridStyle = {
    minHeight: "83vh",
    marginTop: 10,
  };

  const theme = "default-dark";

  const handleCopyToClipboard = (data) => {
    navigator.clipboard.writeText(data);
  };
  // Context menu for stock grid, to allow copying of data such as product number
  const renderRowContextMenu = useCallback(
    (menuProps, { rowProps, columnProps }) => {
      menuProps.autoDismiss = true;
      menuProps.items = [
        {
          label: "Copy Order Number ",
          onClick: () => handleCopyToClipboard(rowProps.data.OrderNo),
        },
      ];
    },
    []
  );

  return (
    <div className="m-3">
      <>
        <div className="">
          <ProgressBar
            style={{ height: "35px" }}
            now={countOfProgess}
            // label={`${parseInt(countOfProgess)}%`}
          />
        </div>
        <ReactDataGrid
          idProperty="OrderNo"
          columns={columns}
          dataSource={dataSource}
          style={gridStyle}
          theme={theme}
          loading={isLoading}
          //selected={selected}
          // onSelectionChange={onSelectionChange}
          renderRowContextMenu={renderRowContextMenu}
          // defaultSortInfo={defaultSortInfo}
          // handle={setGridRef_shiplist}
        />
      </>
    </div>
  );
}

export default Picking;
